export default class UserOnboardingProgressRetrievalError extends Error{

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, UserOnboardingProgressRetrievalError.prototype);
    }
    
}